import { createAppRequest } from "@/services/request";
import type { ApiRequestOptions } from "./types/common";

const request = createAppRequest();
const BASE_PATH = "/bff/zy-crm";

export type CrmAiModelBinding = {
  connectorUuid: string;
  connectorName?: string;
  providerOfficial?: boolean;
  modelRef: string;
  modelLabel?: string;
  lifecycleStatus?: string;
  source?: string;
  modelOfficial?: boolean;
};

export type CrmChatModelOption = {
  modelRef: string;
  modelLabel?: string;
  lifecycleStatus?: string;
  source?: string;
  official?: boolean;
};

export type CrmChatModelGroup = {
  connectorUuid: string;
  connectorName?: string;
  official?: boolean;
  models: CrmChatModelOption[];
};

export type ChatModelReadiness = {
  ready: boolean;
  hasBoundModel: boolean;
};

export async function queryCrmAiModelBinding(options?: ApiRequestOptions) {
  return request<CrmAiModelBinding | null>(`${BASE_PATH}/ai-model-binding`, {
    method: "GET",
    ...(options || {}),
  });
}

export async function saveCrmAiModelBinding(
  payload: { connectorUuid: string; modelRef: string },
  options?: ApiRequestOptions,
) {
  return request<CrmAiModelBinding>(`${BASE_PATH}/ai-model-binding`, {
    method: "PUT",
    data: payload,
    ...(options || {}),
  });
}

export async function queryCrmChatModels(options?: ApiRequestOptions) {
  return request<CrmChatModelGroup[]>(`${BASE_PATH}/ai/chat-models`, {
    method: "GET",
    ...(options || {}),
  });
}

export async function queryChatModelReadiness(options?: ApiRequestOptions) {
  return request<ChatModelReadiness>(`${BASE_PATH}/ai/chat-model-readiness`, {
    method: "GET",
    ...(options || {}),
  });
}
